import { API_URLS, fetchJson } from "@solomon-apps/shared";
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { decodeReserveHistory, type ReserveSnapshot } from "./reserveHistory";

export async function fetchReserveHistory(from: string, to: string, signal?: AbortSignal): Promise<ReserveSnapshot[]> {
    const rows: ReserveSnapshot[] = [];
    const limit = 366;
    for (let offset = 0; offset < limit * 20; offset += limit) {
        const query = new URLSearchParams({ from, to, limit: String(limit), offset: String(offset) });
        const page = decodeReserveHistory(
            await fetchJson<unknown>(`${API_URLS.SOLOMON_DATA}/api/solomon-protocol/reserve-history?${query}`, signal)
        );
        rows.push(...page.data);
        if (!page.hasMore) return rows;
        if (page.data.length !== limit) throw new Error("Incomplete reserve history page");
    }
    throw new Error("Reserve history exceeds the page limit");
}

export function useReserveHistory(): UseQueryResult<ReserveSnapshot[], Error> {
    const today = new Date().toISOString().slice(0, 10);
    const midnight = Date.parse(`${today}T00:00:00Z`);
    const from = new Date(midnight - 90 * 86400000).toISOString().slice(0, 10);
    const to = new Date(midnight + 86400000).toISOString().slice(0, 10);
    return useQuery({
        queryKey: ["reserve-history", from, to],
        queryFn: ({ signal }) => fetchReserveHistory(from, to, signal),
        staleTime: 5 * 60 * 1000,
        refetchInterval: 5 * 60 * 1000,
        retry: 2
    });
}
